/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_P1dInputs */

const en_mk_sol_lembaga_p1d = /** @type {(inputs: Mk_Sol_Lembaga_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every newcomer is trained from scratch because the way of working was never written down.`)
};

const id_mk_sol_lembaga_p1d = /** @type {(inputs: Mk_Sol_Lembaga_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap orang baru dilatih ulang dari nol karena cara kerjanya tidak pernah tertulis.`)
};

/**
* | output |
* | --- |
* | "Every newcomer is trained from scratch because the way of working was never written down." |
*
* @param {Mk_Sol_Lembaga_P1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_p1d = /** @type {((inputs?: Mk_Sol_Lembaga_P1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_P1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_p1d(inputs)
	return en_mk_sol_lembaga_p1d(inputs)
});